import Select from "react-select";
import { useTranslation } from "react-i18next";
import { AccountingEntity, getAccountingEntityId } from "../../models/AccountingEntity";

interface AccountingEntityDropdownProps {
  selectedEntityId: string;
  handleChange: (selectedEntityId: string) => void;
  entities: AccountingEntity[];
}

const AccountingEntityDropdown: React.FC<AccountingEntityDropdownProps> = ({
  selectedEntityId,
  handleChange,
  entities,
}) => {
  const { t } = useTranslation();

  // Create options with funeral home names prioritized
  const entityOptions = entities.map((entity) => {
    const funeralHomeNames = entity.FUNERALHOMES.map(fh => fh.NAME).join(", ");
    const entityId = getAccountingEntityId(entity);
    
    return {
      value: entityId,
      label: funeralHomeNames,
      sublabel: `Costcode: ${entity.COSTCODE}`,
      searchableText: `${funeralHomeNames} ${entity.COSTCODE}`.toLowerCase(),
    };
  });

  const handleSelectChange = (selectedOption: any) => {
    handleChange(selectedOption?.value || "");
  };

  // Add placeholder option
  entityOptions.unshift({ 
    value: "", 
    label: t("funeralhome.select"),
    sublabel: "",
    searchableText: ""
  });

  // Custom format option label to show costcode as secondary info
  const formatOptionLabel = ({ label, sublabel }: any) => (
    <div>
      <div style={{ fontWeight: 500 }}>{label}</div>
      {sublabel && (
        <div style={{ fontSize: "0.85em", color: "#6c757d" }}>
          {sublabel}
        </div>
      )}
    </div>
  );

  // Custom filter function that searches both funeral home names and costcode
  const filterOption = (option: any, inputValue: string) => {
    if (!inputValue) return true;
    return option.data.searchableText.includes(inputValue.toLowerCase());
  };

  return (
    <Select
      value={entityOptions.find((option) => option.value === selectedEntityId)}
      onChange={handleSelectChange}
      options={entityOptions}
      placeholder={t("funeralhome.select")}
      formatOptionLabel={formatOptionLabel}
      filterOption={filterOption}
      isClearable
    />
  );
};

export default AccountingEntityDropdown;
